import request from './request.js';
import {requestbody} from './request.js'

// 供应商基本信息表分页查询
export async function hmdgl_page(params = {
}) {
return await requestbody('graylist/supplier/page', 'post', params)
}

// 查看供应商详情
export async function hmdgl_detail(params = {
}) {
return await requestbody('graylist/supplier/detail', 'post', params)
}

// 手动添加
export async function hmdgl_save(params = {
}) {
return await requestbody('graylist-supplier/save', 'post', params)
}
// 黑名单移入移出
export async function hmdgl_updateBlankList(params = {
}) {
return await requestbody('graylist/supplier/updateBlankList', 'post', params)
}
// 灰名单标签的批量保存
export async function hmdgl_suppliersave(params = {
}) {
return await requestbody('graylist-supplierlabel/supplier/save', 'post', params)
}
// 查询当个公司的标签列表
export async function hmdgl_list(params = {
}) {
return await requestbody('graylist-supplierlabel/supplier/list', 'post', params)
}
// 业务方类型设置
export async function hmdgl_updateLabel(params = {
}) {
return await requestbody('graylist/supplier/updateLabel', 'post', params)
}
// 获取案件详情
export async function hmdgl_violationDetail(params = {
}) {
return await request('graylist/supplier/violationDetail', 'post', params)
}
// 获取失信详情
export async function hmdgl_executedDetail(params = {
}) {
return await request('graylist/supplier/executedDetail', 'post', params)
}
// 查看所有可见公司
export async function hmdgl_comapny(params = {
}) {
return await requestbody('report/query/comapny', 'post', params)
}
//多级菜单获取
export async function groupList(params = {

}) {
    return await requestbody('/system/dept/getDeptTreeTableList', 'get', params)
}
//手工录入保存
export async function hmdgl_saveCompany(params = {

}) {
    return await requestbody('/graylist/supplier/saveCompany', 'post', params)
}
//删除
export async function hmdgl_deletes(params = {
}) {
    return await requestbody('/graylist/supplier/deletes', 'post', params)
}
//初始化黑名单
export async function hmdgl_init(params = {
}) {
    return await requestbody('graylist/supplier/init', 'post', params)
}
//单条数据查询
export async function hmdgl_dantsjcx(params = {
}) {
    return await request('graylist/supplier/getOne', 'post', params)
}
//单条数据修改
export async function hmdgl_updateCompany(params = {
}) {
    return await requestbody('graylist/supplier/updateCompany', 'post', params)
}
//供应商风险查询
export async function hmdgl_gysfxcx(params = {
}) {
    return await requestbody('graylist/supplier/riskInfo', 'post', params)
}